module.exports = __webpack_public_path__ + "static/media/palette.ce3ed644.png";